// extracted by mini-css-extract-plugin
export default {"page":"hhQvCx5KtX8MqwD36koL"};